module.exports = (parcelRequire.load("ehJ5h")).then(() => parcelRequire('bLP21'));